import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/constants";

export const WhatsAppButton = () => (
  <a
    href={`https://wa.me/${COMPANY.whatsapp}?text=Hi%20Prime%20Volt%2C%20I%27d%20like%20to%20discuss%20a%20panel%20requirement.`}
    target="_blank"
    rel="noreferrer"
    data-testid="floating-whatsapp"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-20 left-4 sm:bottom-6 sm:left-6 z-40 inline-flex items-center gap-2 bg-[#22C55E] hover:bg-[#16A34A] text-white px-3.5 py-3 sm:px-4 font-bold uppercase tracking-wide text-xs shadow-[4px_4px_0_0_#000] hover:shadow-[2px_2px_0_0_#000] hover:translate-x-[2px] hover:translate-y-[2px] transition-all border-2 border-zinc-950"
  >
    <MessageCircle className="h-5 w-5" strokeWidth={2.5} />
    <span className="hidden sm:inline">WhatsApp</span>
  </a>
);
